// Translation for hr
export const hr = {
        common: {
            save: 'Spremi',
            cancel: 'Otkaži',
            close: 'Zatvori',
            delete: 'Obriši',
            edit: 'Uredi',
            activate: 'Aktiviraj',
            add: 'Dodaj',
            saving: 'Spremanje...',
            loading: 'Učitavanje...',
            active: 'AKTIVNO',
            inUse: 'U upotrebi',
            test: 'Test',
            searchApps: 'Pretraži aplikacije...',
            betaBanner: 'BETA - Usluga nije dostupna!'
        },
        header: {
            creditBalance: 'Stanje',
            minutes: 'MIN'
        },
        auth: {
            signIn: 'Prijava',
            signUp: 'Registracija',
            username: 'Korisničko ime',
            password: 'Lozinka',
            continue: 'Nastavi',
            noAccount: 'Nemaš račun?',
            hasAccount: 'Već imaš račun?',
            loginError: 'Greška pri prijavi',
            invalidCredentials: 'Nevaljano korisničko ime ili lozinka',
            rateLimited: 'Previše pokušaja prijave. Molim čekaj.',
            sessionExpired: 'Tvoja sesija je istekla. Molim koristi novu čarobnu vezu.',
            magicLinkInvalid: 'Veza za prijavu je nevaljana ili je istekla.',
            magicLinkSuccess: 'Dobrodošao! Uspješno si se prijavio.',
            magicLinkProcessing: 'Obrada prijave...',
            connectionError: 'Greška veze. Molim pokušaj ponovno.'
        },
        profile: {
            myProgress: 'Moj Napredak u Učenju',
            signOut: 'Odjava',
            plan: 'Plan: '
        },
        settings: {
            title: 'Postavke',
            tabs: {
                uiSettings: 'UI Postavke',
                systemPrompt: 'Sistemska Uputa',
                llmProfiles: 'LLM Profili',
                ttsProfiles: 'TTS Profili',
                language: 'Jezik',
            },
            uiSettings: {
                title: 'Korisničko Sučelje',
                themeMode: 'Način Teme',
                darkMode: 'Tamni Način',
                lightMode: 'Svjetli Način',
                themeColor: 'Boja Teme',
                themeColorDesc: 'Odaberi boju naglaška za gumbe, ikone i istaknute dijelove',
                background: 'Pozadina',
                backgroundDesc: 'Odaberi pozadinu za tvoj radni prostor',
                selectBackgroundColor: 'Odaberi Boju Pozadine',
                backgrounds: {
                    cyberSchooling: 'Cyber Schooling',
                    focus: 'Fokus',
                    concentration: 'Koncentracija',
                    relaxation: 'Opuštanje',
                    lianas: 'Lijeske',
                    color: 'Boja'
                },
                backgroundColors: {
                    deepDark: 'Duboko Tamno',
                    darkGrey: 'Tamno Sivo',
                    midnightBlue: 'Ponoćno Plavo',
                    indigo: 'Indigo',
                    darkTeal: 'Tamno Tirkizno',
                    brown: 'Smeđe',
                    darkRed: 'Tamno Crveno',
                    deepPurple: 'Duboko Ljubičasto',
                    pureWhite: 'Čisto Bijelo',
                    softWhite: 'Meko Bijelo',
                    lightGrey: 'Svjetlo Sivo',
                    paleBlue: 'Blijedo Plavo',
                    paleGreen: 'Blijedo Zeleno',
                    paleOrange: 'Blijedo Narančasto',
                    lavender: 'Lavanda',
                    blueGrey: 'Plavo-Sivo'
                }
            },
            systemPrompt: {
                label: 'Sistemska Uputa:',
                placeholder: 'Učitavanje sistemske upute...',
                emptyError: 'Sistemska uputa ne može biti prazna!',
                saveSuccess: '✓ Sistemska uputa je uspješno spremljena!',
                loadError: 'Greška pri učitavanju sistemske upute',
                saveError: 'Greška pri spremanju'
            },
            llmProfiles: {
                addButton: '+ Dodaj Novu Konekciju',
                newConnection: 'Nova Konekcija',
                editConnection: 'Uredi Konekciju',
                emptyState: 'Nema dostupnih LLM konekcija. Klikni dolje za dodavanje.',
                loadingProfiles: 'Učitavanje profila...',
                nameLabel: 'Ime *',
                namePlaceholder: 'npr. OpenAI GPT-4',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'API Ključ *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'Model *',
                modelPlaceholder: 'gpt-4, mistral-tiny, itd.',
                allFieldsRequired: 'Sva polja moraju biti ispunjena!',
                saveSuccess: '✓ Profil je uspješno spremljen!',
                deleteConfirm: 'Jeste li sigurni da želite obrisati "{name}"?',
                profileNotFound: 'Profil nije pronađen!',
                loadError: 'Greška pri učitavanju profila',
                saveError: 'Greška pri spremanju',
                activateError: 'Greška pri aktiviranju',
                deleteError: 'Greška pri brisanju',
                modelInfo: 'Model: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ Dodaj Novi Glas',
                newVoice: 'Novi Glas',
                editVoice: 'Uredi Glas',
                emptyState: 'Nema dostupnih TTS profila. Klikni dolje za dodavanje.',
                loadingProfiles: 'Učitavanje TTS profila...',
                nameLabel: 'Ime',
                namePlaceholder: 'npr. Moj ElevenLabs Adam',
                providerLabel: 'Davatelj',
                providerPlaceholder: 'npr. ElevenLabs, OpenAI, Piper',
                providerPiper: 'Piper (Local)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'API Ključ *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'ID Modela *',
                modelIdPlaceholder: 'npr. eleven_monolingual_v1',
                voiceIdLabel: 'ID Glasa',
                voiceIdPlaceholder: 'npr. pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'Sva polja moraju biti ispunjena!',
                saveSuccess: '✓ TTS profil je uspješno spremljen!',
                deleteConfirm: 'Jeste li sigurni da želite obrisati "{name}"?',
                loadError: 'Greška pri učitavanju TTS profila',
                saveError: 'Greška pri spremanju',
                activateError: 'Greška pri aktiviranju',
                deleteError: 'Greška pri brisanju'
            },
            language: {
                title: 'Odaberi Jezik',
                description: 'Odaberi svoj preferirani jezik za korisničko sučelje'
            },
        },
        chat: {
            ready: 'Spremno',
            start: 'POČETAK',
            stop: 'ZAUSTAVI',
            initialMessage: 'Klikni POČETAK za razgovor u realnom vremenu.',
            listening: 'Slušam...',
            speaking: 'Thorsten govori...',
            userLabel: 'Ti',
            aiLabel: 'AI',
            modalTitle: 'Thorsten AI Chat',
            inputPlaceholder: 'Napišite poruku...',
            send: 'Pošalji',
            loginRequired: 'Molim prijava za korištenje ove usluge.',
            loginButton: 'Prijava Sada',
            magicLinkRequired: 'Molim koristi čarobnu vezu za prijavu.',
            creditLimitError: 'Vaša satna kvota je iscrpljena. Nadogradite svoj plan (Medium/Premium) za nastavak.',
            serviceDisabled: 'Usluga chata trenutno nije dostupna. Pokušajte ponovo kasnije.'
        },
        notifications: {
            error: 'Greška',
            success: 'Uspjeh',
            info: 'Informacija',
            unknownError: 'Došlo je do nepoznate greške'
        },
        cookie: {
            message: 'Ova web stranica koristi kolačiće kako bi vam pružila najbolje moguće iskustvo korisnika.',
            accept: 'Prihvati'
        },
        curriculum: {
                buttonLabel: 'Kurikulum',
                buttonTitle: 'Prikaži sadržaj kurikuluma',
                modalTitle: '{app} Kurikulum',
                sections: {
                    topic: 'Tema kurikuluma',
                    explanation: 'Objašnjenje prilagođeno djeci',
                    studentProfile: 'Profil učenika'
                },
                topic: {
                    empty: 'Nijedna tema kurikuluma nije povezana s ovom mikro-aplikacijom u pozadini.',
                    missingDetail: 'Detaljni podaci kurikuluma za ovu mikro-aplikaciju još nisu dostupni u pozadini.',
                    learningGoals: 'Ciljevi učenja',
                    prerequisites: 'Preduvjeti',
                    unitLabel: 'Jedinica',
                    durationLabel: 'Trajanje',
                    difficultyLabel: 'Težina',
                    hours: 'h',
                    minutes: 'min'
                },
                explanation: {
                    empty: 'Nema dostupnog objašnjenja prilagođenog djeci.',
                    loadingPrepare: 'AI priprema objašnjenje',
                    loadingExplain: 'AI objašnjava temu jezikom prilagođenim djeci',
                    requestFailed: 'Objašnjenje prilagođeno djeci nije moglo biti generirano.'
                },
                studentProfile: {
                    country: 'Država',
                    region: 'Regija',
                    schoolType: 'Vrsta škole',
                    grade: 'Razred',
                    noContext: 'Nema dostupnog konteksta učenika.',
                    childProfileNotFound: 'Nije pronađen profil učenika u pozadini za trenutnu prijavu.',
                    loginProfileIncomplete: 'Profil prijave još ne sadrži potpuni kontekst učenika.',
                    educationContextNotFound: 'Profil učenika je pronađen, ali nije postavljen kurikulum.',
                    noToken: 'Nije pronađen prijavljeni učenik.'
                },
                errors: {
                    signInRequired: 'Prijavite se za pregled kurikuluma.',
                    appIdMissing: 'Nedostaje ID aplikacije.',
                    loadFailed: 'Učitavanje podataka kurikuluma nije uspjelo.'
                }
            }
    };
